import { Menu, Transition } from "@headlessui/react";
import {
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpDownIcon,
    StopIcon,
} from "@heroicons/react/24/outline";
import { Fragment } from "react";
import DatePicker from "react-datepicker";
import es from "date-fns/locale/es";

const WEEK_DAYS = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
];
const MONTHS = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

export default function DayCalendar({ selectedDate, setSelectedDate }) {
    const handleChange = (e) => {
        setSelectedDate(e);
    };

    const goPrevDay = () => {
        setSelectedDate(
            new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate() - 1
            )
        );
    };

    const goNextDay = () => {
        setSelectedDate(
            new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate() + 1
            )
        );
    };

    const goToday = () => {
        setSelectedDate(new Date());
    };

    const dayName = WEEK_DAYS[selectedDate.getDay()];
    const day = selectedDate.getDate();
    const month = MONTHS[selectedDate.getMonth()];
    const year = selectedDate.getFullYear();

    return (
        <div className="flex flex-col gap-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-3 w-full sm:w-72">
            <div className="flex justify-between items-start gap-3">
                <Menu as="div" className="relative flex-1 min-w-0">
                    <Menu.Button className="flex items-center gap-1 text-left text-gray-800 dark:text-gray-200 hover:text-blue-400 dark:hover:text-blue-400 transition-all w-full">
                        <span className="text-base font-semibold truncate">
                            {month} {year}
                        </span>
                        <ChevronUpDownIcon className="h-5 w-5 shrink-0" />
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute left-0 z-10 mt-2 w-64 max-w-[calc(100vw-2rem)] origin-top-left rounded-md bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <DatePicker
                                selected={selectedDate}
                                onChange={handleChange}
                                locale={es}
                                inline
                            />
                        </Menu.Items>
                    </Transition>
                </Menu>

                <div className="flex items-center gap-1 shrink-0">
                    <button
                        type="button"
                        onClick={goPrevDay}
                        className="text-gray-600 dark:text-gray-400 p-1 hover:text-blue-400 dark:hover:text-blue-400 transition-all"
                        title="Día anterior"
                    >
                        <ChevronLeftIcon className="h-6 w-6" />
                    </button>
                    <button
                        type="button"
                        onClick={goToday}
                        className="text-gray-600 dark:text-gray-400 rounded-md px-2 py-1 text-xs font-semibold hover:text-blue-400 dark:hover:text-blue-400 transition-all"
                        title="Ir a hoy"
                    >
                        <StopIcon className="h-6 w-6" />
                    </button>
                    <button
                        type="button"
                        onClick={goNextDay}
                        className="text-gray-600 dark:text-gray-400 p-1 hover:text-blue-400 dark:hover:text-blue-400 transition-all"
                        title="Día siguiente"
                    >
                        <ChevronRightIcon className="h-6 w-6" />
                    </button>
                </div>
            </div>

            <div className="text-center">
                <h2 className="text-xl text-gray-800 dark:text-gray-200 font-semibold">
                    {dayName}
                </h2>
                <p className="text-4xl text-gray-900 dark:text-white font-bold leading-none">
                    {day}
                </p>
            </div>
        </div>
    );
}
